import { AMENITY_GROUP, useBookingRecoilValue, useNewNavigate } from "@/shared/client";
import { type RoomType } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { CustomButton, CustomText } from "./roomDescription.style";

export const RoomDescription = ({ room }: { room: RoomType }) => {
    const { onNavigate } = useNewNavigate();
    const bookingURL = useBookingRecoilValue();

    const { room_idx, room_name, room_intro, room_type, imgList, amenity, amenity_icon } = { ...room };
    const { isMobile } = MEDIA();

    const activeAmenities = AMENITY_GROUP.filter(({ name }) => amenity_icon[name as keyof typeof amenity_icon]);
    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    return (
        <Flex
            key={room_idx}
            maxW="1600px"
            w="100%"
            flexDir={isMobile ? "column" : "row"}
            gap={isMobile ? "16px" : "48px"}
        >
            <Box
                maxW="728px"
                w="100%"
                h={isMobile ? "296px" : "568px"}
                background={imgList[1] ? `url(${imgList[1].img_URL}) no-repeat center/cover` : "gray.100"}
            ></Box>
            <Flex
                flexShrink={isMobile ? 0 : 1}
                w="100%"
                flexDir="column"
                justifyContent="space-between"
                p={isMobile ? "0" : "24px"}
                boxSizing="border-box"
                rowGap={isMobile ? "32px" : "auto"}
            >
                <Flex flexDir="column" gap={isMobile ? "16px" : "29px"}>
                    <Box>
                        <Text
                            fontFamily="Noto Serif KR"
                            fontSize={isMobile ? "20px" : "32px"}
                            fontWeight="400"
                            lineHeight="140%"
                        >
                            {room_name}
                        </Text>
                        <Box
                            sx={{
                                "& p": {
                                    fontFamily: "Pretendard",
                                    fontSize: isMobile ? "14px" : "16px",
                                    lineHeight: "140%",
                                    fontWeight: "300",
                                    color: "#6b6b6b",
                                },
                            }}
                        >
                            <Text>{room_intro}</Text>
                            <Text>{room_type}</Text>
                        </Box>
                    </Box>
                    <Flex flexDir="column" rowGap="8px" overflow="hidden">
                        <CustomText>AMENITIES & SERVICE 어메니티 & 서비스</CustomText>
                        <Box display="-webkit-box" w="100%" overflowX="scroll" flexWrap="nowrap">
                            {activeAmenities.map(({ name, url }) => (
                                <Box
                                    key={name}
                                    w="64px"
                                    h="64px"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    borderRadius="md"
                                    bg="rgba(255,255,255,0.1)"
                                >
                                    <Image src={url} alt={name} w="100%" h="100%" objectFit="contain" />
                                </Box>
                            ))}
                        </Box>
                        <Flex flexWrap="wrap">
                            <Text>{amenity}</Text>
                        </Flex>
                    </Flex>
                </Flex>
                <Flex gap="16px">
                    <CustomButton
                        onClick={() => onLink(bookingURL)}
                        style={{ backgroundColor: "#749fa5", color: "#fff", border: "none" }}
                    >
                        예약하기
                    </CustomButton>
                    <CustomButton onClick={() => onNavigate({ path: "/guide" })}>이용안내</CustomButton>
                </Flex>
            </Flex>
        </Flex>
    );
};
